export default __webpack_public_path__ + "static/media/pagination-next.d6b4311d.svg";